exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-search--header {\n    color: rgb(118,118,118);\n}\n.quickSearchPanel > .expansion-panel__header {\n    padding-top: 0px;\n    padding-bottom: 0px;\n    height: 15px;\n}\n.quickSearchPanel  .card__text {\n    padding-top: 0px;\n}\n#quickSearchOuter {\n    display: inline-block;\n    margin-left: 10px;\n    margin-right: 20px;\n    width: 500px;\n}\n#quickSearchInput {\n    border: none;\n}\n#searchProgressIcon {\n    display: inline-block;\n    position: relative;\n    top:10px;\n}\n\n", ""]);

// exports
